module.exports = __webpack_public_path__ + "img/touch-id.14f8e228.png";